export function parseToken(token: string) {
	return token.replaceAll(/ /g, '+');
}
